import '@fontsource/gloock/400.css'
import '@fontsource/hanken-grotesk/400.css'
import '@fontsource/hanken-grotesk/600.css'
import '@fontsource/hanken-grotesk/700.css'
import '@fontsource/hanken-grotesk/800.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/composants.css'
import './navigation/navigation.css'
import './recherche/recherche.css'
import './decouverte/decouverte.css'
import './admin/admin.css'
import './serie/serie.css'
import './style.css'

import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

/**
 * Polices embarquées avec l'application (12 oct.) : rien n'est demandé à
 * Google, et elles marchent hors ligne.
 *
 * La page de démonstration des composants (/#demo) n'existe qu'en
 * développement : import.meta.env.DEV vaut false à la construction, et le
 * module n'entre pas dans le site en ligne. L'application est chargée à
 * part, pour que la démonstration s'ouvre même sans les variables Supabase.
 */
const App = lazy(() => import('./App.js').then((m) => ({ default: m.App })))
const Demo = import.meta.env.DEV
  ? lazy(() => import('./demo/Demo.js').then((m) => ({ default: m.Demo })))
  : null

const root = document.getElementById('root')
if (root)
  createRoot(root).render(
    <StrictMode>
      <Suspense fallback={null}>
        {Demo && window.location.hash === '#demo' ? <Demo /> : <App />}
      </Suspense>
    </StrictMode>,
  )
